import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { DesignSystemModule } from '@compeople-shared/design-system-angular';
import { Subject } from 'rxjs';
import { NotificationType } from '../notification.service';

@Component({
  selector: 'spa-notification-toast',
  imports: [DesignSystemModule],
  template: `
    <dx-notification-toast
      data-testid="toast"
      [closeafter]="closeAfter()"
      [titlestring]="titleString()"
      [type]="type()"
      [visible]="true"
      (closeNotification)="onCloseNotification()"
    >
      <dx-text>{{ message() }}</dx-text>
    </dx-notification-toast>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationToastComponent {
  type = input<NotificationType>('default');
  titleString = input<string>('');
  message = input<string>('');
  closeAfter = input.required<number>();

  closeNotification = new Subject<void>();

  onCloseNotification() {
    this.closeNotification.next();
    this.closeNotification.complete();
  }
}
